import React from "react";
import { Link } from "react-router-dom";
import { NAV, CONTENT, CONTACTS } from "../../data/content";
import { useLang } from "../../context/LanguageContext";
import { scrollToId } from "../../lib/api";

export const Footer = () => {
  const { lang } = useLang();
  const t = CONTENT[lang].footer;
  const year = new Date().getFullYear();

  return (
    <footer data-testid="site-footer" className="bg-[#050505] px-6 md:px-12 pt-20 pb-10 border-t border-white/10">
      <div className="max-w-[1400px] mx-auto">
        <button data-testid="footer-lets-talk" onClick={() => scrollToId("contatti")}
          className="font-heading font-black text-6xl md:text-8xl lg:text-9xl tracking-tighter text-white hover:text-blue-500 transition-colors leading-none">
          Let's Talk.
        </button>

        <div className="mt-16 grid md:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <img src="/appforge-logo.png" alt="AppForge Studio" className="w-9 h-9 rounded-lg object-cover" />
              <span className="font-heading font-bold text-lg text-white">AppForge <span className="text-blue-500">Studio</span></span>
            </div>
            <p className="text-sm text-zinc-500 leading-relaxed max-w-xs">{t.desc}</p>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-600 mb-4">{t.quickLinks}</div>
            <ul className="space-y-2.5">
              {NAV[lang].slice(0, 5).map((n) => (
                <li key={n.id}>
                  <button onClick={() => scrollToId(n.id)} className="text-sm text-zinc-400 hover:text-white transition-colors">{n.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-600 mb-4">{t.legal}</div>
            <ul className="space-y-2.5">
              <li><Link data-testid="footer-privacy" to="/legal/privacy" className="text-sm text-zinc-400 hover:text-white transition-colors">{t.privacy}</Link></li>
              <li><Link data-testid="footer-cookie" to="/legal/cookie" className="text-sm text-zinc-400 hover:text-white transition-colors">{t.cookie}</Link></li>
              <li><Link data-testid="footer-terms" to="/legal/termini" className="text-sm text-zinc-400 hover:text-white transition-colors">{t.terms}</Link></li>
            </ul>
          </div>

          <div>
            <div className="text-xs font-mono uppercase tracking-widest text-zinc-600 mb-4">Contatti</div>
            <ul className="space-y-2.5">
              <li><a href={`tel:+39${CONTACTS.phone}`} className="text-sm text-zinc-400 hover:text-white transition-colors">{CONTACTS.phoneDisplay}</a></li>
              <li><a href={`mailto:${CONTACTS.email}`} className="text-sm text-zinc-400 hover:text-white transition-colors break-all">{CONTACTS.email}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">© {year} AppForge Studio. {t.rights}</p>
          <Link data-testid="footer-admin-link" to="/admin/login" className="text-xs text-zinc-700 hover:text-zinc-400 transition-colors font-mono">{t.admin}</Link>
        </div>
      </div>
    </footer>
  );
};
